import Cookie from "js-cookie";

export const NEW_SHARE_TOKEN = "NEW_SHARE_TOKEN";
export const OLD_SHARE_TOKEN = "OLD_SHARE_TOKEN";
export const DASHBOARD_ID = "DASHBOARD_ID";

const useDashboardShare = () => {
  const getItem = (value: string) => Cookie.get(value) || "";
  const setItem = (key: string, value: string) => Cookie.set(key, value);
  const removeItem = (key: string) => Cookie.remove(key);

  return {
    getItem,
    setItem,
    removeItem,
  };
};

export default useDashboardShare;
